import { Component, ElementRef, AfterViewChecked } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import * as _ from 'lodash';
import { Title } from '@angular/platform-browser';
import { AuthService } from './auth.service';
import { InitialDataService } from './initial-data.service';

@Component({
    selector: 'gaweb-root',
    template: `<router-outlet></router-outlet>`,
    styles: []
})
export class AppComponent implements AfterViewChecked {

    private scrollExecuted: boolean = false;

    constructor(elm: ElementRef,
        private initialDataService: InitialDataService,
        private activatedRoute: ActivatedRoute) {
        initialDataService.initialData = JSON.parse(elm.nativeElement.getAttribute('initial-data'));
    }

    ngAfterViewChecked() {
        // Automatic scroll to error summary in angular 2
        if (!this.scrollExecuted) {
            let routeFragmentSubscription: Subscription;
            routeFragmentSubscription =
                this.activatedRoute.fragment
                    .subscribe(fragment => {
                        if (fragment) {
                            let element = document.getElementById(fragment);
                            if (element) {
                                element.scrollIntoView(true);
                                this.scrollExecuted = true;
                                setTimeout(
                                    () => {
                                        routeFragmentSubscription.unsubscribe();
                                    }, 500);
                            }
                        }
                    });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts